import React, { useMemo, useReducer } from 'react';
import { CurrentDeviceControlObj } from '../../../../../model/DeviceAdminModel';
import { WithLockedValidation } from '../../../../common';
import { RoleStore, roleContextInitialState, roleContextReducer } from '../RoleContext/context';
import { ModalComponent } from './ModalComponent';

type Props = {
	currentDevice: CurrentDeviceControlObj;
};

const RoleModal: React.FC<Props> = WithLockedValidation(({ currentDevice }) => {
	const [modalContextState, dispatchContextAction] = useReducer(roleContextReducer, roleContextInitialState);
	const { Provider } = RoleStore;

	const roleModalContextValue = useMemo(
		() => ({
			roleContextInitialState: {
				...modalContextState,
			},
			dispatcher: dispatchContextAction,
		}),
		[modalContextState, dispatchContextAction]
	);

	return (
		<Provider value={roleModalContextValue}>
			<ModalComponent currentDevice={currentDevice} />
		</Provider>
	);
});

export { RoleModal };
